export const GET_ORDERS = `loja/list-order-admin`
export const GET_ORDERS_STATUS = `admin/status-order-list`
